export default "__VITE_ASSET___2gySsXd__"